import React from 'react';
import { SortOption } from '../types';
import { ICONS } from '../constants';
import { useTranslation } from '../hooks/useTranslation';

interface SortToggleProps {
  sortOption: SortOption;
  onSortChange: (sortOption: SortOption) => void;
}

const SortToggle: React.FC<SortToggleProps> = ({
  sortOption,
  onSortChange,
}) => {
  const { t } = useTranslation();

  const handleToggle = () => {
    // Переключаем между NAME_ASC и NAME_DESC
    const newSortOption = sortOption === SortOption.NAME_ASC 
      ? SortOption.NAME_DESC 
      : SortOption.NAME_ASC;
    onSortChange(newSortOption);
  };

  const isAscending = sortOption === SortOption.NAME_ASC;

  return (
    <button
      onClick={handleToggle}
      className="p-2 rounded-md transition-colors bg-gray-800 hover:bg-gray-600 text-gray-400 hover:text-white border border-gray-700"
      title={isAscending ? t('sortToggle.sortAZ') : t('sortToggle.sortZA')}
      type="button"
    >
      {isAscending ? (
        <ICONS.ChevronUp className="w-5 h-5" />
      ) : (
        <ICONS.ChevronDown className="w-5 h-5" />
      )}
    </button>
  );
};

export default SortToggle;
